import { ArticleDto, EntreeHistorique } from "@/types/article.types";
import API from "./api";

export interface ArticleFilters {
  rubriqueId?: number;
  categorieId?: number;
  type?: string;
  langue?: string;
  paysIds?: number[];
  /** N'expose que les articles publiés depuis cette date ISO (usage : récap hebdomadaire). */
  publieDepuis?: string;
  /** N'expose que les articles d'un auteur donné (usage admin : "articles d'un rédacteur/partenaire"). */
  auteurId?: string;
}

const ArticleService = {
  getAll: async (page = 0, taille = 20, statut?: string, filters?: ArticleFilters) => {
    const response = await API.get("/articles", {
      params: {
        page,
        taille,
        statut,
        rubriqueId: filters?.rubriqueId,
        categorieId: filters?.categorieId,
        type: filters?.type,
        langue: filters?.langue,
        // Envoyé en liste séparée par des virgules : Spring lie nativement
        // "1,2,3" vers un List<Long> côté @RequestParam, contrairement à la
        // notation "paysIds[]=1&paysIds[]=2" qu'axios produirait par défaut
        // pour un tableau (non reconnue par Spring).
        paysIds: filters?.paysIds?.length ? filters.paysIds.join(",") : undefined,
        publieDepuis: filters?.publieDepuis,
        auteurId: filters?.auteurId,
      },
    });

    return response.data.donnees;
  },

  getStatistiquesAuteurs: async (depuis?: string, jusqua?: string) => {
    const response = await API.get("/articles/statistiques-auteurs", {
      params: { depuis, jusqua },
    });
    return response.data.donnees;
  },

  getStatistiquesSponsorisation: async (depuis?: string, jusqua?: string) => {
    const response = await API.get("/articles/statistiques-sponsorisation", {
      params: { depuis, jusqua },
    });
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/articles/${id}`);
    return response.data.donnees;
  },

  getMesArticles: async () => {
    const response = await API.get("/articles/mes-articles");
    return response.data.donnees;
  },

  /** `forcer` : valider malgré un droit de réponse en attente (dérogation tracée). */
  valider: async (arg: number | { id: number; forcer?: boolean }) => {
    const { id, forcer } = typeof arg === "number" ? { id: arg, forcer: false } : arg;
    const response = await API.post(`/articles/${id}/valider`, null, {
      params: forcer ? { forcer: true } : undefined,
    });
    return response.data.donnees;
  },

  /** `definitif` : rejet (article archivé) au lieu d'une demande de révision. */
  refuser: async ({ id, commentaire, definitif }: { id: number; commentaire: string; definitif?: boolean }) => {
    const response = await API.post(`/articles/${id}/refuser`, { commentaire, definitif: !!definitif });
    return response.data.donnees;
  },

  historique: async (id: number): Promise<EntreeHistorique[]> => {
    const response = await API.get(`/articles/${id}/historique`);
    return response.data.donnees;
  },

  resoumettre: async (id: number) => {
    const response = await API.post(`/articles/${id}/resoumettre`);
    return response.data.donnees;
  },

  getBySlug: async (slug: string) => {
    const response = await API.get(`/articles/slug/${slug}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/articles", payload);
    console.log("/articles", payload);
    return response.data.donnees;
  },

   update: async (id: number, payload: any): Promise<ArticleDto> => {
    const response = await API.put(`/articles/${id}`, payload);
    return response.data.donnees;
  },

  publish: async (arg: number | { id: number; forcer?: boolean }) => {
    const { id, forcer } = typeof arg === "number" ? { id: arg, forcer: false } : arg;
    const response = await API.post(`/articles/${id}/publier`, null, {
      params: forcer ? { forcer: true } : undefined,
    });
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/articles/${id}`);
    return response.data.donnees;
  },
};

export default ArticleService;
